import { pickBy } from 'lodash';

export const flattenNotableClients = (notableClients = []) => {
    if (notableClients?.length === 0) {
        return;
    }

    return notableClients.map?.(({ name, enriched_details, company }) =>
        name || company?.name || enriched_details?.name
    ).join();
};

export const removeEmptyProps = (obj) => pickBy(obj, (value) => (value !== undefined && value !== null));
